import React, { useContext } from "react";
import { Form, InputNumber, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ThemeContext } from "../../../../../../../contexts/ThemeContext";

interface IProps {
    label: string;
    tooltip?: string;
    value: any;
    onChange: (val: any) => void;
    disabled?: boolean;
    error?: { message?: string };
    addonBefore?: string;
    addonAfter?: string;
    placeholder?: string;
    min?: number;
    required?: boolean;
}

export default function ConfigDivisorField({
    label,
    tooltip,
    value,
    onChange,
    disabled = false,
    error,
    addonBefore = "R$",
    addonAfter,
    placeholder = "0",
    min = 1,
    required = true,
}: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    return (
        <div style={{ width: "100%" }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    marginBottom: 6,
                    minHeight: 22,
                }}
            >
                <Typography.Text strong style={{ fontSize: 12.5, color: isDark ? "#f0f0f0" : "#334155" }}>
                    {label} {required && <span style={{ color: "#ff4d4f" }}>*</span>}
                </Typography.Text>
                {tooltip && (
                    <Tooltip title={tooltip}>
                        <InfoCircleOutlined style={{ color: "#94a3b8", fontSize: 12, cursor: "pointer" }} />
                    </Tooltip>
                )}
            </div>
            <Form.Item
                style={{ marginBottom: 0 }}
                validateStatus={error ? "error" : undefined}
                help={error?.message}
            >
                <InputNumber
                    value={value}
                    onChange={onChange}
                    type="number"
                    min={min}
                    addonBefore={addonBefore}
                    addonAfter={addonAfter}
                    placeholder={placeholder}
                    disabled={disabled}
                    style={{ width: "100%" }}
                />
            </Form.Item>
        </div>
    );
}
